import React from "react";
import "./Breadcrumbs.scss";
import { Link } from "react-router-dom";
import * as _ from "lodash-es";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ISupplierModel from "../../../models/ISupplierModel";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    navItems?: IBreadcrumbs[];
    crumbs?: IBreadcrumbs[];
    hasTopMargin?: boolean;
    className?: string;
    supplierModel?: ISupplierModel;
};

const Breadcrumbs = ({ navItems = [], crumbs = [], hasTopMargin = true, className = "", supplierModel }: Props) => {
    const _crumbs = navItems && navItems.length ? navItems : crumbs;

    if (!_crumbs.length) {
        // console.log("No Nav Items...");
    }

    const breadcrumbString = _crumbs.map((navItem: IBreadcrumbs, index: number) => {
        let navItemTitle: any = navItem.title;

        const hasMoreCrumbs = _crumbs.length > index + 1;

        if (!_.isObject(navItem.title)) {
            const title = navItem.skipTranslate ? navItem.title : _.lowerCase(navItem.title).replace(/ /g, "_");

            navItemTitle = (
                <OwLabel
                    className={hasMoreCrumbs ? "pointer" : ""}
                    title={title}
                    isSupplierVendorOverride={navItem.isVendorNameOverride}
                    supplierModel={supplierModel}
                    noBottomMargin={true}
                    skipTranslate={navItem.skipTranslate}
                />
            );
        }

        return (
            <span key={index}>
                {hasMoreCrumbs ? <Link to={navItem.url}>{navItemTitle}</Link> : null}
                {hasMoreCrumbs ? null : <span>{navItemTitle}</span>}
                {hasMoreCrumbs ? <i className={"fad fa-slash-forward ms-3 me-3 "} /> : null}
            </span>
        );
    });

    let topMargin = "mt-3";

    if (!hasTopMargin) {
        topMargin = "";
    }

    return <div className={`breadcrumbs ${topMargin} d-print-none ${className}`}>{breadcrumbString}</div>;
};

export default Breadcrumbs;
